import { LOCKED_RANKING_TOOLTIP_DESCRIPTION, LOCKED_RANKING_TOOLTIP_TITLE } from '../../constants/elevation';

export const getRankingInfoTooltipTitle = (ranking) => {
    if (ranking === null) {
        return LOCKED_RANKING_TOOLTIP_TITLE
    }

    const roundedRank = Math.round(ranking <= 1 ? 1 : ranking)

    return `Being in the top ${roundedRank}% means you perform better than ${100 - roundedRank}% of advisers in this category`
}

export const getRankingInfoTooltipDescription = (ranking) => {
    if (ranking === null) {
        return LOCKED_RANKING_TOOLTIP_DESCRIPTION
    }

    const roundedRank = Math.round(ranking <= 1 ? 1 : ranking)

    return `Top ${roundedRank}% of advisers`
}